import {
  createRestApiClient,
  currentLanguage,
  currentUser,
  load
} from "scrivito"

export async function getPisaClient(subPath: string) {
  const user = await load(() => currentUser())
  const config = await pisaConfig(subPath)
  if (!config || !user) return null

  const { url, headers } = config

  return createRestApiClient(url, {
    headers,
    audience: import.meta.env.VITE_PISA_IAM_AUDIENCE
  })
}

export async function pisaConfig(subPath: string) {
  if (
    !import.meta.env.VITE_PISA_BASE ||
    !import.meta.env.VITE_PISA_IAM_AUDIENCE
  ) {
    return null
  }
  return {
    url: `${import.meta.env.VITE_PISA_BASE}/${subPath}`,
    audience: import.meta.env.VITE_PISA_IAM_AUDIENCE,
    headers: {
      "Accept-Language": await load(() => currentLanguage() ?? "en")
    }
  }
}
